import { useEffect, useState } from "react";
import useManageApi from "../../../hooks/useManageApi";
import { LoadingComponent, LoadingButton } from "usbc-web-react-library";
import ValidationErrors from "../../shared/ValidationErrors";

const TermsAndConditions = () => {
    const { getTermsAndConditions, loading: termsAndConditionsLoading } = useManageApi();
    const { acceptTermsAndConditions, loading: acceptTermsAndConditionsLoading } = useManageApi();
    const [validationErrors, setValidationErrors] = useState(null);
    const [termsAndConditionsViewModel, setTermsAndConditionsViewModel] = useState(null);

    useEffect(() => {
        const currentUrl = new URL(window.location.href);
        const currentUrlParams = currentUrl.searchParams;
        const returnUrl = currentUrlParams.get('returnUrl');
        const urlParams = returnUrl ? { returnUrl: returnUrl } : null;

        getTermsAndConditions({ 
            params: urlParams,
            onError: (error) =>{
                setValidationErrors(error);
                window.scrollTo(0, 0);
            }
        }).then((result) => {
            setTermsAndConditionsViewModel(result?.data);
        });
    }, []);

    function handleAcceptTermsAndConditions() {
        acceptTermsAndConditions({ params: { returnUrl: termsAndConditionsViewModel?.returnUrl } }).then((result) => {
            window.location.href = result.data;
        })
    }

    function redirectToAthleteSafetyPortal() {
        window.location.href = "/AthleteSafetyPortal/AthleteSafetyRVP";
    }

    return (
        <LoadingComponent isLoading={() => termsAndConditionsLoading} description={"Loading Terms and Conditions... Please Wait."}>
            <h4><strong>SafeSport Terms And Conditions</strong></h4>
            {validationErrors && <ValidationErrors className="validation-errors alert alert-danger mt-3" validationErrors={validationErrors} />}
            {termsAndConditionsViewModel?.isError === true && !validationErrors &&
                 <div className="rvp-header-card card alert alert-danger">
                    <div className="rvp-header-card-text container">
                        There was an issue getting user information, please contact support.
                    </div>
                 </div>
            }
            {termsAndConditionsViewModel?.isError !== true && !validationErrors &&
                <div className="form-group">
                    <div className="text-end">
                        {termsAndConditionsViewModel && <label style={{ fontWeight: "bold" }}>{termsAndConditionsViewModel?.fullName} ({termsAndConditionsViewModel?.nationalId})</label>}
                    </div>
                    <br />
                    <div>
                        <div>
                            <br />
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {(termsAndConditionsViewModel?.returnUrl && termsAndConditionsViewModel?.returnUrl === "NotAssociated")
                                        && <>
                                            <tr>
                                                <td className=" text-center"><label>There is an issue with your SafeSport account, please contact</label></td>
                                            </tr>
                                            <tr>
                                                <td className=" text-center"><label>USBC Rules for resolution at 800-514-2695 Ext. 8955.</label> </td>
                                            </tr>
                                            <tr>
                                                <td className=" text-center">
                                                    <button id="reloadterms" type="button" role="button" onClick={redirectToAthleteSafetyPortal} className="btn btn-primary btn-block">Athlete Safety Portal</button>
                                                </td>
                                            </tr>
                                        </>
                                    }
                                    {!(termsAndConditionsViewModel?.returnUrl && termsAndConditionsViewModel?.returnUrl === "NotAssociated")
                                        && termsAndConditionsViewModel?.termsAndConditionsText &&
                                        <>
                                            <tr>
                                                <td className=" text-start">
                                                    <div style={{ height: "600px", overflow: "auto" }}>
                                                        <div dangerouslySetInnerHTML={{ __html: termsAndConditionsViewModel?.termsAndConditionsText }} />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr><td>&nbsp;</td></tr>
                                            <tr>
                                                <td className=" text-center">
                                                    <LoadingButton id="acceptButton" type="button" onClick={handleAcceptTermsAndConditions} className="accept-tc-submit-btn btn btn-primary" loadingText='Accepting' loading={acceptTermsAndConditionsLoading}>
                                                        Accept Terms and Conditions
                                                    </LoadingButton>
                                                </td>
                                            </tr>
                                        </>
                                    }
                                    {!(termsAndConditionsViewModel?.returnUrl && termsAndConditionsViewModel?.returnUrl === "NotAssociated")
                                        && termsAndConditionsViewModel?.termsAndConditionsText === null &&
                                        <>
                                            <tr>
                                                <td className=" text-center"><label>SafeSport has not completed processing your registration request.</label></td>
                                            </tr>
                                            <tr>
                                                <td className=" text-center"><label>Please try again.</label> </td>
                                            </tr>
                                            <tr>
                                                <td className=" text-center">
                                                    <button id="reloadterms" type="button" role="button" onClick={redirectToAthleteSafetyPortal} className="btn btn-primary btn-block">Athlete Safety Portal</button>
                                                </td>
                                            </tr>
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <br />
                            <br />
                            <span>
                                Should you have any questions about the SafeSport Terms and Conditions, please go to <a href="http://www.Bowl.com/RVP" target="_blank" rel="noopener noreferrer">BOWL.com/RVP</a> or contact <a href="mailto:RegisteredVolunteers@bowl.com?subject=Registered%20Volunteer%20Question" target="_blank" style={{ fontSize: "14px" }}>RVP@bowl.com</a>.
                            </span>
                            <br />
                        </div>
                    </div >
                </div >
            }
        </LoadingComponent>
    );
}

export default TermsAndConditions